var moduleMap = {
	"./App": () => {
		return Promise.all(/* __federation_expose_App */[__webpack_require__.e(959), __webpack_require__.e(859), __webpack_require__.e(253), __webpack_require__.e(570), __webpack_require__.e(289)]).then(() => (() => ((__webpack_require__(2026)))));
	},
	"./useLogout": () => {
		return Promise.all(/* __federation_expose_useLogout */[__webpack_require__.e(959), __webpack_require__.e(859), __webpack_require__.e(253), __webpack_require__.e(570), __webpack_require__.e(263)]).then(() => (() => ((__webpack_require__(8775)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope, remoteEntryInitOptions) => {
	return __webpack_require__.federation.bundlerRuntime.initContainerEntry({	webpackRequire: __webpack_require__,
		shareScope: shareScope,
		initScope: initScope,
		remoteEntryInitOptions: remoteEntryInitOptions,
		shareScopeKey: "default"
	})
};
// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});